var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterDepricatedImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62391_26121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3775 27.2396L45.56 13.0771H42.6725L32.095 25.3746L23.65 13.0771H13.9L26.6775 31.6721L13.9 46.5246H16.7875L27.96 33.5371L36.8825 46.5221H46.6325L33.3825 27.2371L33.3775 27.2396ZM29.4225 31.8271L28.1275 29.9746L17.8275 15.2496H22.2625L30.575 27.1421L31.87 28.9946L42.675 44.4496H38.24L29.4225 31.8271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8978 51.0997C32.573 53.3641 31.9107 54.4966 32.0097 55.4257C32.096 56.236 32.527 56.9722 33.195 57.4511C33.9606 58 35.2846 58 37.9325 58H52.0675C54.7154 58 56.0392 58 56.8048 57.4511C57.4728 56.9722 57.904 56.236 57.9903 55.4257C58.0893 54.4966 57.4272 53.3641 56.1024 51.0997L49.0374 39.0248C47.7126 36.7605 47.0499 35.6285 46.1851 35.2486C45.4307 34.9171 44.5688 34.9171 43.8145 35.2486C42.95 35.6283 42.2877 36.7603 40.964 39.0228L33.8978 51.0997Z",
    fill: "#E6181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 42.1876V47.9375M33.8978 51.0997C32.573 53.3641 31.9107 54.4966 32.0097 55.4257C32.096 56.236 32.527 56.9722 33.195 57.4511C33.9606 58 35.2846 58 37.9325 58H52.0675C54.7154 58 56.0392 58 56.8048 57.4511C57.4728 56.9722 57.904 56.236 57.9903 55.4257C58.0893 54.4966 57.4272 53.3641 56.1024 51.0997L49.0374 39.0248C47.7126 36.7605 47.0499 35.6285 46.1851 35.2486C45.4307 34.9171 44.5688 34.9171 43.8145 35.2486C42.95 35.6283 42.2877 36.7603 40.964 39.0228L33.8978 51.0997ZM45.074 52.25V52.3938L44.9274 52.3941V52.25H45.074Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62391_26121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterDepricatedImage);
export default __webpack_public_path__ + "static/media/twitter_depricated_image.7dbe33620e5b2d906267ccd7fd4f389d.svg";
export { ForwardRef as ReactComponent };